import { createFileRoute } from '@tanstack/react-router'

import { NpsSection } from '@/features/organization/nps-section'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute('/_app/organizacao/nps')({
  component: NpsTab,
})

function NpsTab() {
  const { currentOrgId } = useAuth()
  return <NpsSection orgId={currentOrgId} />
}
